<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SingleSelect from 'dashboard/components-next/filter/inputs/SingleSelect.vue';

const params = defineModel({ type: Array, required: true });
const { t } = useI18n();
const options = computed(() => [
  {
    id: 'agent_response_overdue',
    name: t('SLA_VIOLATIONS.TYPES.agent_response_overdue'),
  },
]);
const selected = computed({
  get: () =>
    options.value.find(option => option.id === params.value[0]) || null,
  set: option => {
    params.value = [option.id];
  },
});
</script>

<template>
  <SingleSelect
    v-model="selected"
    :options="options"
    :placeholder="t('SLA_VIOLATIONS.TYPE')"
    disable-deselect
    disable-search
  />
</template>
